import { render, staticRenderFns } from "./editdalamprovinsi.vue?vue&type=template&id=367a475e&"
import script from "./editdalamprovinsi.vue?vue&type=script&lang=js&"
export * from "./editdalamprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports